import React from "react";

function Insta(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg id="Instagram" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
			<g id="Group_98">
				<g id="Group_97">
					<path id="Path_1222" d="M16,0A16,16,0,1,0,32,16,16.047,16.047,0,0,0,16,0Z" />
				</g>
			</g>
			<path
				id="Path_1228"
				data-name="Path 1228"
				d="M16,10.9A5.1,5.1,0,1,0,21.1,16,5.121,5.121,0,0,0,16,10.9Zm0,8.4A3.3,3.3,0,1,1,19.3,16,3.329,3.329,0,0,1,16,19.3Zm6.4-8.6a1.2,1.2,0,1,1-1.2-1.2A1.287,1.287,0,0,1,22.4,10.7Zm3.4,1.2a5.577,5.577,0,0,0-1.6-4.1,5.905,5.905,0,0,0-4.1-1.6c-1.6-.1-6.5-.1-8.1,0A5.577,5.577,0,0,0,7.9,7.8a6.4,6.4,0,0,0-1.6,4.1c-.1,1.6-.1,6.5,0,8.1a5.577,5.577,0,0,0,1.6,4.1A6.4,6.4,0,0,0,12,25.7c1.6.1,6.5.1,8.1,0a5.577,5.577,0,0,0,4.1-1.6A5.905,5.905,0,0,0,25.8,20c.1-1.6.1-6.4,0-8.1Zm-2.1,9.9a3.239,3.239,0,0,1-1.9,1.9c-1.3.5-4.4.4-5.8.4s-4.5.1-5.8-.4a3.239,3.239,0,0,1-1.9-1.9c-.5-1.3-.4-4.4-.4-5.8s-.1-4.5.4-5.8a3.239,3.239,0,0,1,1.9-1.9c1.3-.5,4.4-.4,5.8-.4s4.5-.1,5.8.4a3.239,3.239,0,0,1,1.9,1.9c.5,1.3.4,4.4.4,5.8S24.2,20.5,23.7,21.8Z"
				fill="#fff"
			/>
		</svg>
	);
}

export default Insta;
